import { num, formatNum } from 'Shared/utilities';
import Checkbox from 'Components/Forms/Elements/Checkbox';
import bemit from 'Functions/bemit';
import { isTrue } from 'Shared/utilities';
const NO_STATUS = {};
export default function SelectBookingServices({
  booking,
  ...props
}) {
  if (booking?.services?.length > 0 === false) return null;
  const services = booking.services.map(function (row, i) {
    const service = row.service_info || {};
    const modifiers = [];
    const is__canceled = isTrue(row.canceled);
    if (is__canceled) {
      modifiers.push('canceled');
    }
    return /*#__PURE__*/React.createElement("tr", {
      className: bemit('c-selectable-service', modifiers),
      key: i
    }, /*#__PURE__*/React.createElement("td", {
      className: "c-selectable-service__cell Service-select"
    }, is__canceled ? undefined : /*#__PURE__*/React.createElement(Checkbox, {
      onChange: props.onSelect,
      className: bemit('c-form-element', ['in-cell'].concat(is__canceled ? ['disabled'] : [])),
      value: props.selected?.[i],
      name: String(i),
      "full-width": false,
      status: NO_STATUS,
      disabled: is__canceled
    })), /*#__PURE__*/React.createElement("td", {
      className: "c-selectable-service__cell Service-title"
    }, service._servicetitle?.title), /*#__PURE__*/React.createElement("td", {
      className: "c-selectable-service__cell Service-qty"
    }, service.unit === 'per_hour' ? booking.hours_count + 'h' : row.quantity), /*#__PURE__*/React.createElement("td", {
      className: "c-selectable-service__cell Service-cost"
    }, formatNum(row.total_price, '0,0[.]00'), "\u20AC"));
  });
  return /*#__PURE__*/React.createElement("table", {
    className: "selectable-services"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    className: "c-selectable-service"
  }, /*#__PURE__*/React.createElement("td", {
    className: "c-selectable-service__cell Service-select"
  }), /*#__PURE__*/React.createElement("td", {
    className: "c-selectable-service__cell Service-title"
  }, "Service"), /*#__PURE__*/React.createElement("td", {
    className: "c-selectable-service__cell Service-qty"
  }, "Quantit\xE9"), /*#__PURE__*/React.createElement("td", {
    className: "c-selectable-service__cell Service-cost"
  }, "Prix TTC"))), /*#__PURE__*/React.createElement("tbody", null, services));
}
